import is from '@sindresorhus/is';

import type { JobProfileComponent, JobProfileLegacy } from '~/shared/data-contract/job-profile';
import type { JobProfileSkill } from '~/shared/data-contract/skill';
import type { LanguageCodeForJSA } from '~/shared/internationalization';

export const normalizeJobProfile = (
    profile: JobProfileComponent,
    selectedLanguage: LanguageCodeForJSA,
    skills: readonly JobProfileSkill[],
): JobProfileLegacy => {
    const { translations, ...rest } = profile;

    const filteredTranslations = translations.filter((translation) => is.nonEmptyString(translation.title));

    const translationsToSend = filteredTranslations.filter((translation) => translation.language === selectedLanguage);

    const processedTranslations = translationsToSend.map((translation) => ({
        ...translation,
        structured: translation.structured?.map((structuredItem) => ({
            ...structuredItem,
            value: structuredItem.value.replace(/^<p>/, '').replace(/<\/p>$/, ''),
        })),
        title: translation.title.trim(),
    }));

    return {
        ...rest,
        skills: [...skills],
        state: 'draft',
        translations: processedTranslations,
    };
};
